// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const LinkClearFilters: React.FC<{ width?: number; height?: number; color1?: string; className?: string }> = ({
    width = undefined,
    height = undefined,
    color1 = "#e00b5a",
    className,
}) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 13 11" width={width} height={height}>
            <path
                fill="currentColor"
                d="M8.322 1.205a.583.583 0 0 0-.8 0L4.904 3.7l4.305 4.11 2.618-2.496a.52.52 0 0 0 0-.763zM1.748 6.707a.52.52 0 0 0 0 .762l2.075 1.979a.58.58 0 0 0 .401.157h2.864a.58.58 0 0 0 .4-.157l1.187-1.131L4.368 4.21zM6.987.697a1.366 1.366 0 0 1 1.868 0l3.507 3.343a1.217 1.217 0 0 1 0 1.78L8.39 9.608h4.06a.37.37 0 0 1 .377.36.37.37 0 0 1-.377.36H7.166v-.002l-.078.002H4.224c-.351 0-.686-.133-.934-.369L1.214 7.98a1.217 1.217 0 0 1 0-1.78z"
            />
        </svg>
    );
};

export default React.memo(LinkClearFilters);
